import { __assign, __read, __rest } from "tslib";
import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { Icon } from "../icon";
import { MenuGroup } from "./MenuGroup";
import { SubMenu } from "./SubMenu";
import { MenuItem } from "./MenuItem";
import { useDefault } from "../_util/use-default";
import { Tooltip } from "../tooltip";
import { useConfig } from "../_util/config-context";
import { Badge } from "../badge";
import { MenuContext } from "./MenuContext";
import { forwardRefWithStatics } from "../_util/forward-ref-with-statics";
export var Menu = forwardRefWithStatics(function Menu(_a, ref) {
    var _b, _c;
    var theme = _a.theme, title = _a.title, tag = _a.tag, icon = _a.icon, back = _a.back, children = _a.children, className = _a.className, collapsable = _a.collapsable, _d = _a.defaultCollapsed, defaultCollapsed = _d === void 0 ? false : _d, collapsed = _a.collapsed, onCollapsedChange = _a.onCollapsedChange, props = __rest(_a, ["theme", "title", "tag", "icon", "back", "children", "className", "collapsable", "defaultCollapsed", "collapsed", "onCollapsedChange"]);
    var classPrefix = useConfig().classPrefix;
    // eslint-disable-next-line no-param-reassign
    _b = __read(useDefault(collapsed, defaultCollapsed, onCollapsedChange), 2), collapsed = _b[0], onCollapsedChange = _b[1];
    var _e = __read(useState(false), 2), hover = _e[0], setHover = _e[1];
    var _f = __read(useState(false), 2), mobileCollapsed = _f[0], setMobileCollapsed = _f[1];
    useEffect(function () {
        if (!collapsed) {
            setHover(false);
        }
    }, [collapsed]);
    if (Array.isArray(icon)) {
        // eslint-disable-next-line
        icon = icon[0];
    }
    var renderBack = typeof back === "object"
        ? function () {
            var _a;
            var title = back.title, description = back.description, _b = back.onClick, onClick = _b === void 0 ? function () { return null; } : _b, tooltip = back.tooltip;
            var titleList = (React.createElement("div", { className: classPrefix + "-menu__title-list" },
                React.createElement("div", { className: classNames(classPrefix + "-h2", (_a = {},
                        _a[classPrefix + "-menu__title-main"] = !!description,
                        _a)) }, title),
                React.createElement("div", { className: classPrefix + "-menu__title-text" }, description)));
            return (React.createElement("div", { className: classPrefix + "-menu__title-back" },
                React.createElement("a", { className: classPrefix + "-menu__back", onClick: onClick },
                    React.createElement(Icon, { type: "btnback" })),
                tooltip ? (React.createElement(Tooltip, { title: tooltip }, titleList)) : (titleList)));
        }
        : function () { return null; };
    return (React.createElement(MenuContext.Provider, { value: { collapsed: collapsed && !hover, setMobileCollapsed: setMobileCollapsed } },
        React.createElement("div", __assign({ ref: ref, className: classNames(classPrefix + "-menu", className, (_c = {},
                _c[classPrefix + "-menu--light"] = theme !== "dark",
                _c[classPrefix + "-menu-is-locked"] = collapsed,
                _c[classPrefix + "-menu-is-collapsed"] = collapsed && !hover,
                _c[classPrefix + "-menu-mobile-collapsed"] = mobileCollapsed,
                _c)) }, props),
            React.createElement("div", { className: classPrefix + "-menu__header", onMouseEnter: function () { return collapsed && setHover(true); }, onMouseLeave: function () { return collapsed && setHover(false); }, onClick: function () { return setMobileCollapsed(function (collapsed) { return !collapsed; }); } },
                !!title && (React.createElement("div", { className: classPrefix + "-menu__title" },
                    !!icon &&
                        (typeof icon === "string" ? (React.createElement("img", { className: classPrefix + "-menu__title-icon", src: icon, alt: "icon" })) : (icon)),
                    React.createElement("h2", { className: classPrefix + "-h2" },
                        title,
                        !!tag && React.createElement(Badge, null, tag)),
                    React.createElement(Icon, { type: "arrowdown" }))),
                renderBack()),
            React.createElement("div", { className: classPrefix + "-menu__body", onMouseEnter: function () { return collapsed && setHover(true); }, onMouseLeave: function () { return collapsed && setHover(false); } },
                React.createElement("ul", { className: classPrefix + "-menu__list" }, children)),
            !!collapsable && (React.createElement("div", { className: classPrefix + "-menu__footer" },
                React.createElement("div", { className: classPrefix + "-menu__fold", onClick: function () { return onCollapsedChange(!collapsed); } },
                    React.createElement("div", { className: classPrefix + "-menu__fold-icon" },
                        React.createElement(Icon, { type: "fold" }))))))));
}, {
    Group: MenuGroup,
    SubMenu: SubMenu,
    Item: MenuItem,
});
Menu.displayName = "Menu";
//# sourceMappingURL=Menu.js.map